export enum FieldDomainType {
  none = 0,
  fixed = 1,
  dynamic = 2,
  definedInFlow = 3
}
